var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#BEC0C2;}\r\n\t.st1{fill:#002D62;}\r\n\t.st2{fill:#FDBB30;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.6,100.7c-20.1-24.2-48.9-37.7-81.3-37.7l-129.5,0L47.7,336.1l110.6,0.1l15.9-66.1c14.8,0,53.9,0,53.8,0 c37,0.3,67.4-12.3,87.9-36.3C353,193.4,346.4,134.3,318.6,100.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.4,262.9L152.6,329l-96,0l56.9-258.8l123.7,0.1c30.8,0.1,57.2,12.5,75.8,35c27.4,33.1,30.1,88.1-2.7,123.9 c-20.1,23.6-49.6,34-82.3,33.7L168.4,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.8,127.7l54.2,0c6.2,0,12.9,5.2,10,13.1c-1.8,4.9-3.1,10.6-3.8,15.9c-0.5,4.2,4.2,6.8,6.8,6.8l110.5,0.1 c2.1,0,3.2-0.6,3.2-1.6c0-1-0.1-4.7-0.5-7.2c-0.4-2.4-0.8-2.9-2.8-2.9c-13.8,0-19.4-6.1-33.8-15.5c-14.4-9.3-35.6-14.7-53.8-14.7 l-88.7-0.1L100.8,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.7,199.3c-1.9-4.1-3.7-9-4.8-13.4c-1.4-5.7-6.2-10.4-14.5-10.4l-58.2,0l1.4-6.5l188.5,0.1 c1.9,0,1.5,0.8,1.4,2.9c-0.1,2.1-0.6,5.9-0.9,8.2c-0.3,2.3-2.2,1.7-4,1.8c-4.2,0.1-12.1,1.1-16.7,4.5c-7.8,5.9-24.5,16.2-33.8,19.2 c-10,3.2-47.6,14.7-58.6-6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.9,222.8l98.4,0.1c4.3,0,8.1,1,11,3.4c8.3,6.9,19.1,11.8,30.5,15.1c5.1,1.5,14-0.4,21.9-4.9 c19.7-11.1,32.4-32.3,36.5-46c1.1-3.6-1-3.3-3.8-3.1c-8.3,0.6-17,8.1-28.5,15.4c-11.5,7.3-34.8,14.2-57,14.2l-107.8-0.1L79.9,222.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M224.2,91c1.4-0.2,6.4-0.5,9.1,0.5c18.7,7.4,36.4,26.8,43.8,47.5c1.4,4,1.8,6.5,0,6.7 c-8.6,0.9-12.6-3.3-22.6-10.1c-10.1-6.8-19.4-11.5-32.1-15.5c-12.6-4-35.5-4.6-38.5-4.7c-3-0.1-2.6-1.3-1.3-2.6 C193.6,101.9,208.3,93.9,224.2,91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M313.9,162c0.1,0.8-0.8,1.7-1.8,1.7c-0.1,0-21.6,0-21.6,0c-2.8,0-2.8-1.3-2.9-2.9c-0.1-1.6-0.6-4.7-0.6-6.6 c-0.1-1.8-0.8-3.9,1.7-4.9c6-2.5,11.7-8.4,14.3-13.4c0.9-1.7,2.2-4.5,3.6-2.1C311.7,141.8,313.3,151.9,313.9,162z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M306.2,200.7c-0.4,0.7-1.7,1.3-2.2,0.1c-3.1-8.4-10.6-14.2-15.8-17.1c-1.6-0.9-1.7-1.9-1.5-3.4 c0.2-1.5,0.9-6.4,1-8.5c0.1-1.6,0.7-2.8,2-2.8l22.5,0c0.8,0,1.8,0.7,1.8,1.3C313.9,181,310.7,191.6,306.2,200.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M247.8,242.9c-1.6,0.2-5-0.3,0.4-3.5c16.3-9.5,30.9-31.8,34.7-44.5c1.5-4.9,1.6-5.1,3.5-4.6 c2.5,0.7,6.4,4.1,9.4,8.3c3,4.1,4.3,12.2,2.6,14.6C286.8,228.8,268.1,239.9,247.8,242.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.3,142.1c-3.8,2-4.5,1.7-5.3-1.2c-7.1-24.9-28-43.3-36.6-48.7c-1.6-1-1.2-1.7,0-1.6 c20.5,2.7,40.5,13.9,50.6,29.2C303.8,128.5,293,140.1,289.3,142.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInd);
export default __webpack_public_path__ + "static/media/IND.ff18f06099fb91beeb906f1edd3d8ae9.svg";
export { ForwardRef as ReactComponent };